





































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwTable, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import {
  ActivtyData,
  TABLE_ROW_HEIGHT_NORMAL,
  TABLE_ROW_HEIGHT_MAX,
  TABLE_HEADER_HEIGHT,
} from './activity-logs.mappings';
import { CreateElement, VNode } from 'vue';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import ExportcsvService from '@/shared/msw-exportcsv.service';
const cssPrefix = 'viewMoreDetailsComponent';
@Component({
  components: {
    ...UUIFComponent,
  },
  directives:{
    tooltip,
  },
})
export default class ViewMoreDetailsComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: Array })
  data: ActivtyData[];
  @Prop()
  show: boolean;

  rowData: ActivtyData[];

  tableRowHeight: number = TABLE_ROW_HEIGHT_NORMAL || 0;
  tableHeaderHeight: number = TABLE_HEADER_HEIGHT || 0;

  scalableColumns: string[] = ['ACTIVITY DETAILS', 'SKU DESCRIPTION'];

  @Watch('data', { deep: true, immediate: true })
  onDataChange() {
    this.rowData = [...this.data];
  }

  get getData(): ActivtyData[] {
    return this.rowData && this.rowData.length > 0 ? this.rowData : [];
  }

  mounted() {
    this.rowData = [...this.data];
  }

  showHeader(tableHeader: string = '') :boolean {
    return (tableHeader ? true : false);
  }

  tableColConfig(data: any): TableColumnConfig[] {
    const config: TableColumnConfig[] = [];
    data &&
    data.length > 0 &&
    data.map((ele: any) => {
      config.push({
        key: ele.identifyName,
        dataKey: ele.identifyName,
        title: ele.displayName,
        width: this.manageWidth(ele),
        sorter: true,
        scalable: this.manageScalable(ele, data),
        render: (h: CreateElement, data: { entry: TableEntry, index: number }) => { // tslint:disable-line
          return (
            <div class={`${cssPrefix}__tableEntryClass`}>
              {data.entry[ele.identifyName] ? <span class={`${cssPrefix}__tableEntryfield`}
                    v-tooltip={{
                      placement: 'top',
                      persistent: false,
                      compact: true,
                      content: `${ele.displayName}: ${data.entry[ele.identifyName]}`}}>
                { data.entry[ele.identifyName] }
              </span> : <span></span>}
            </div>) as VNode;
        },
      });
    });
    return config;
  }

  tableData(data: any, tableWrapperRef: string, tableRef: string, header: string): TableEntry[] {
    const tableData:TableEntry[] = [];
    data &&
    data.length > 0 &&
    data.forEach((entry: any, index: any) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = `${index.toString()}-${new Date().getTime()}`;
      tableData.push(newEntry);
    });
    data.length > 0 && this.adjustTableConfig(data, tableWrapperRef, tableRef, this.showHeader(header));
    return tableData;
  }

  closeDialog() {
    this.$emit('closeDialog');
  }
  manageWidth(ele: any) {
    if (ele.displayName === 'STARRED') {
      return 120;
    }
    if (ele.displayName === 'ISDEFAULTGROUP') {
      return 120;
    }
    if (ele.displayName === 'PARTYGROUPNAME') {
      return 150;
    }
    if (ele.displayName === 'ACTIVITY DETAILS') {
      return 150;
    }
    if (ele.displayName === 'SERIAL NUMBER') {
      return 130;
    }
    if (ele.displayName === 'FRIENDLY NAME') {
      return 150;
    }
    if (ele.displayName === 'SKU') {
      return 120;
    }
    if (ele.displayName === 'SKU DESCRIPTION') {
      return 150;
    }
    if (ele.displayName === 'PRODUCT TYPE') {
      return 150;
    }
    if (ele.displayName === 'FIRMWARE VERSION') {
      return 140;
    }
    if (ele.displayName === 'MANAGED BY') {
      return 120;
    }
    if (ele.displayName === 'ACTIVATION KEY') {
      return 120;
    }
    if (ele.displayName === 'START DATE') {
      return 120;
    }
    if (ele.displayName === 'END DATE') {
      return 120;
    }
    if (ele.displayName === 'NODECOUNT') {
      return 120;
    }
    return 180;
  }

  manageScalable(ele: any, data: any) {
    if (data.findIndex((val: any) => { return this.scalableColumns.includes((val.displayName || '')); }) > -1) {
      if (this.scalableColumns.includes((ele.displayName || ''))) {
        return true;
      }
      return false;
    }
    return true;
  }

  adjustTableConfig(data: any, wrapperRef: string, tableRef: string, isShowHeader: boolean) {
    this.$nextTick(() => {
      const rows = data.length || 0;
      const tableWrapper = (this.$refs[wrapperRef] as any)[0];
      const tableWrapperHeight: number = (tableWrapper as HTMLDivElement).offsetHeight || 0;
      const table = ((this.$refs[tableRef] as any)[0] as SwTable);
      this.tableRowHeight = (tableRef === 'tableRef0') ?  TABLE_ROW_HEIGHT_MAX : TABLE_ROW_HEIGHT_NORMAL;
      let tableHeight: number = this.tableRowHeight * rows + this.tableHeaderHeight - (isShowHeader ? 40 : 0);
      tableHeight = tableHeight + 10;
      if (tableHeight > tableWrapperHeight) {
        tableHeight = tableWrapperHeight - (isShowHeader ? 40 : 0);
      }
      const tableStyle = `height: ${tableHeight}px;`;
      if (table) {
        table!.$el!.setAttribute('style', tableStyle);
      }
    });
  }
  exportData(act: any) {
    const columnList = act.colList || [];
    const tableList = act.tableData || [];
    ExportcsvService.startExport(this.mapDataForExport(columnList, tableList), 'Activity.csv');
  }
  mapDataForExport(columns:any[], data: any[]) {
    let tempArr: any = [];
    const tempJson: any = [];
    data.map((dataItem:any) => {
      const obj = {};
      columns.forEach((item) => {
        // @ts-ignore
        obj[item.displayName] = `${dataItem[item.identifyName]}` || '';
      });
      tempJson.push(obj);
    });
    tempArr = tempArr.concat(tempJson);
    return tempArr;
  }
}
